export default __webpack_public_path__ + "static/savings.url-54a817112335ac043f2aa45e8aa59761.svg";